<template lang="pug">
  q-input(v-bind="$attrs" v-model="model")
    template(v-slot:append)
      q-btn(flat dense icon="event" :disable="disable" rounded)
        q-menu(:offset="[10, 15]" anchor="bottom right" self="top right" ref="m")
          q-date(v-model="model" minimal mask="YYYY-MM-DD"
            @input="() => $refs.m.hide()" :options="minDate")
</template>

<script>
export default {
  props: ['value', 'disable', 'minDate'],
  computed: {
    model: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  }
}
</script>
